import React from 'react';
import { useDispatch } from 'react-redux';
import { showChatBot } from '@om/redux/actions/publicWeb/chatBot';
import { OmModal } from '@om/component-library-react';

const HowToDownloadModal = ({ overlayName }) => {
    const disaptch = useDispatch();

    return (
        <OmModal
            onOnClose={() => {
                disaptch(showChatBot());
            }}
            isCentered={true}
            overlayName={overlayName}
        >
            <div slot="modal-content">
                <p>
                    The table can be downloaded as a PDF from the print preview.
                </p>
                <p>
                    Select <strong>Save as PDF</strong> as the printer.
                </p>
                <p>
                    For mobile devices running iOS, use the pinching gesture to
                    make the print expand and fill the screen. Once completed,
                    tap the screen once to reveal the toolbar with the share
                    button. Select share, saving it as a PDF.
                </p>
            </div>
        </OmModal>
    );
};

export default HowToDownloadModal;
